(() => {
  const root = window.Shopify.routes.root;
  let busy = false, allowOnce = false;
  window.galbeCartReady = false;
  function message(text) {
    let el = document.getElementById('galbe-option-errors');
    if (!el) {
      el = document.createElement('div'); el.id='galbe-option-errors'; el.setAttribute('role','alert');
      el.style.cssText='margin:20px 0;padding:14px 16px;background:#fbf1f1;color:#a34f55;font-size:12px;line-height:1.9;letter-spacing:0.03em;text-align:left;';
      const target=document.querySelector('.cart__ctas_wrapper, .cart__ctas');
      if (!target) return;
      target.before(el);
    }
    el.textContent=text;
    el.hidden=!text;
  }
  function buttons() {
    document.querySelectorAll('button[name="checkout"]').forEach(button => {
      const consent = document.getElementById('cta_check');
      button.disabled = !window.galbeCartReady || busy || window.galbeCartMutating || (consent && !consent.checked);
    });
  }
  async function check() {
    const response=await fetch(root+'cart.js',{cache:'no-store',signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('カートを確認できませんでした。ページを再読み込みしてください。');
    const cart=await response.json();
    const errors=window.galbeValidateOptions(cart,40553474097281);
    if (errors.length) throw new Error(errors.join(' '));
    return cart.items.length > 0;
  }
  async function refresh() {
    window.galbeCartReady=false; buttons();
    try {window.galbeCartReady=await check();message('');}
    catch(error){message(error.message);}
    buttons();
  }
  async function checkout(event, button, form) {
    if (allowOnce) {allowOnce=false; return;}
    event.preventDefault();event.stopImmediatePropagation();
    if (busy || window.galbeCartMutating) return;
    if (document.getElementById('cta_check') && !document.getElementById('cta_check').checked) return;
    busy=true;buttons();
    try {
      window.galbeCartReady=await check();
      if (!window.galbeCartReady) throw new Error('カートに商品がありません。');
      if (window.galbeCartMutating) throw new Error('数量の更新中です。更新後にもう一度お試しください。');
      if (!form.reportValidity()) return;
      allowOnce=true;
      if (button) button.disabled=false;
      form.requestSubmit(button || undefined);
      allowOnce=false;
    } catch(error) {window.galbeCartReady=false;message(error.message);}
    finally {busy=false;buttons();}
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('button[name="checkout"]');
    if(button?.form) checkout(event,button,button.form);
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if((form.id==='cart'||form.id==='CartDrawer-Form') && (!event.submitter || event.submitter.name==='checkout')) checkout(event,event.submitter?.name==='checkout'?event.submitter:null,form);
  },true);
  document.addEventListener('change',event=>{
    if(event.target.id==='cta_check') buttons();
  });
  document.addEventListener('galbe:cart-updated',refresh);
  window.addEventListener('pageshow',()=>{if(document.querySelector('button[name="checkout"]')) refresh();});
  if(document.querySelector('button[name="checkout"]')) refresh();
})();
